var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFastForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#03bf0c",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7429 12.1714L3 18.3429V6L11.7429 12.1714Z",
    fill: "#03bf0c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2571 18.3429L21 12.1714L12.2571 6V18.3429Z",
    fill: "#03bf0c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFastForward);
export default __webpack_public_path__ + "static/media/icon-fast-forward.16fa37dd62f51a8816a1f6d1d29579ec.svg";
export { ForwardRef as ReactComponent };